import { createContext, useContext } from "react";

/**
 * Screens contribute their own header (title, breadcrumb, actions) into the
 * layout's header bar. The layout publishes the target element; `PageHeader`
 * portals into it. This keeps the header a layout concern while its contents
 * stay owned by the screen that is routed.
 */
export const HeaderSlotContext = createContext<HTMLElement | null>(null);

export function useHeaderSlot(): HTMLElement | null {
  return useContext(HeaderSlotContext);
}
